import { z } from 'zod';

export const ShippingMethodDTO = z.union([
    z.literal('homedelivery'),
    z.literal('collectionpoint'),
    z.literal('clickandcollect'),
    z.literal('collectionpoint_hd'),
    z.literal('shiptostore'),
]);

export type ShippingMethodDTO = z.infer<typeof ShippingMethodDTO>;
